import { Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from './hooks/useSession';
import { DashboardPage } from './pages/Dashboard';
import { ItemDetalhePage } from './pages/ItemDetalhe';
import { LoginPage } from './pages/Login';
import { PesquisaDetalhePage } from './pages/PesquisaDetalhe';
import { PesquisaNovaPage } from './pages/PesquisaNova';
import { SignupPage } from './pages/Signup';
import { VerifyPage } from './pages/Verify';

const FullscreenSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-navy-500 text-sm">carregando...</div>
  </div>
);

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { data, isPending } = useSession();
  if (isPending) return <FullscreenSpinner />;
  if (!data) return <Navigate to="/login" replace />;
  return <>{children}</>;
};

const GuestOnlyRoute = ({ children }: { children: React.ReactNode }) => {
  const { data, isPending } = useSession();
  if (isPending) return <FullscreenSpinner />;
  if (data) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export const App = () => (
  <Routes>
    <Route
      path="/signup"
      element={
        <GuestOnlyRoute>
          <SignupPage />
        </GuestOnlyRoute>
      }
    />
    <Route
      path="/login"
      element={
        <GuestOnlyRoute>
          <LoginPage />
        </GuestOnlyRoute>
      }
    />
    <Route path="/verify" element={<VerifyPage />} />
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/pesquisas/nova"
      element={
        <ProtectedRoute>
          <PesquisaNovaPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/pesquisas/:id"
      element={
        <ProtectedRoute>
          <PesquisaDetalhePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/pesquisas/:id/itens/:itemId"
      element={
        <ProtectedRoute>
          <ItemDetalhePage />
        </ProtectedRoute>
      }
    />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);
